var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1455_14740",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1455_14740",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAADi0lEQVR4nO2dvWoVQRiGn4iFElEJsbax0MIUWnsFIphCLJSki43oJXjsvAJBG8XaKxAEwdZYKCK2ifEHJZX4QwKxOHvwuNk5O7uzO/Pt7vvAQHJ2vpl39uXbmdnNnoAQQgghhBBC2OMisAV8AlZrxK8AHwPjt7Ky0sH4VeAz8AW4VCN+H5vA3lR5DMx7xM1ndfdQ/KRsecSVkhe0B7wHzs6IOQ28ccQOPT4Yl6ifwO2C+ivAjxlxQ48PpkzYI8bpOZ/9XFTnXVaGGh/VEAsDthzfuiHWLwmW4tcKPg+mqEHLk6a1+CiGABwGHhQcf4LfsnAo8dEMmZB642U9vpIhcx4d5hvxiRH/qHT+DrQoRNRAhhhDhhjjYANtNLJy6BFBc6wyxBgyxBgyxBhNzCF5hrZPaXQOVYYYQ4YYQ4YYo405RPuSAJQhxpAhxpAhxmhiDhnavqNVlCHGkCHGkCHGkCHGkCHGkCHGkCHG6PIzddf+x5qeSihDjCFDjCFDjNGlZ+q+c0On760pQ4whQ4whQ4wRy5AlYBk4CrzC/SrYNnA+sK+yd//aKtEo67js+BLwDbgJPCuo72uK7wmwZkgl49pYZeV5DiwCp4CnwFfgenbshiPmJLDevrRuEpohk8/Xst/XZtQN0eGqpwypwTJwIvfZw5ptdXof4kPbGTIqaKNOP1appDv1sncE3EmswRQpDRllZW6quCb5wZBqDhkBd1tqO9XlrJG5q4kvDig7vg6cA14y/g6QReC7o68zwAXgNfv3ImX9uOrFwldPsHGhk+0R/DaEk/ICOFajH1e9Ti17Y2QIwCHGk/dCSV/bjC9lv2vocNWLRSMZEsuQJojVT9NU0p162StyyBBjyBBj6B1DYyhDjGHlbm+TVM3QslVjVJQhxtA7hnHZLKugDInHLnCriYa6+mCoLqHjvQLs5NrYBa5ZEdg1Qsbbuhk+Aq3dXQ2lbj9RzPARKEMimuEj0Johoe1UNSSqGT4Ch2xIdDOqCrRALEOSmFFFoBViGJLMDF+BfaJsvEnN8BHYN2aNN7kZZQL7iGu8JsyYJbCvFI3XjBkugX0mP15TZhQJ7Dv58ebN2AGuJlMH/MoJOp5STARmLZGTmwHwlv9F3Wf856F9xbQZ4H6hZkjFjBkwvkRtkP6kyIwplhj/48TUJ0dmTLEA3AM+AH9If7LaLhvA5UbOnBBCCCGEEEIY5i87MU9oF0g2KAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsLetter);
export default __webpack_public_path__ + "static/media/newsLetter.b5a907b02b608efd1608d92de56573aa.svg";
export { ForwardRef as ReactComponent };